<template>
  <div>
    <vs-button icon-pack="feather" icon="icon icon-file" @click="add">Novo</vs-button>

    <div class="data-list-container mt-5 p-4" style="border: 1px dashed #ccc; border-radius: 4px;">
      <h4 class="mb-2 ml-1">Planos Ativos - Novo Checkout</h4>
      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado"
        :data="newCheckoutPlans"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>NOME</vs-th>
          <vs-th>ADESÃO</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>VALIDADE</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>ORDEM</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td valign="top" :data="data[idx].name">
              <router-link :to="{ name: 'plano-detalhes', params: { id: data[idx].id } }">{{ data[idx].name }}</router-link>
              <div>
                ID: {{ data[idx].id }}
              </div>

              <div v-show="data[idx].recurring === 'Sim'">
                <div class="mt-2" v-show="data[idx].paypal_plan_id"><strong>PayPal</strong><br>Plan ID: {{ data[idx].paypal_plan_id }} - Product ID: {{ data[idx].paypal_product_id }}</div>
                <div class="mt-2" v-show="data[idx].iugu_plan_id"><strong>Iugu</strong><br>Plan ID: {{ data[idx].iugu_plan_id }}</div>
                <div class="mt-2" v-show="data[idx].galaxpay_plan_id"><strong>GalaxPay</strong><br>Plan ID: {{ data[idx].galaxpay_plan_id }}</div>
              </div>
            </vs-td>
            <vs-td valign="top" :data="data[idx].setup_fee">{{ data[idx].setup_fee | money(data[idx].currency_code) }}</vs-td>
            <vs-td valign="top" :data="data[idx].fixed_price">{{ data[idx].fixed_price | money(data[idx].currency_code)}}</vs-td>
            <vs-td valign="top" :data="data[idx].interval_count">{{ data[idx].interval_count }} {{ data[idx].interval_unit | intervalUnit }}</vs-td>
            <vs-td valign="top" :data="data[idx].recurring" :class="{'text-success': data[idx].recurring === 'Sim', 'text-danger': data[idx].recurring === 'Não'}">{{ data[idx].recurring }}</vs-td>
            <vs-td valign="top" :data="data[idx].status_new_checkout" :class="{'text-success': data[idx].status_new_checkout === 'ACTIVE', 'text-danger': data[idx].status_new_checkout === 'INACTIVE', 'text-warning': data[idx].status_new_checkout === 'HIDDEN'}">{{ data[idx].status_new_checkout | statusPlans }}</vs-td>
            <vs-td valign="top" :data="data[idx].sort">{{ data[idx].sort }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div class="data-list-container mt-5 p-4" style="border: 1px dashed #ccc; border-radius: 4px;">
      <h4 class="mb-2 ml-1">Planos Ativos - Painel/Antigo Checkout</h4>
      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado"
        :data="activePlans"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>NOME</vs-th>
          <vs-th>ADESÃO</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>VALIDADE</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>ORDEM</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td valign="top" :data="data[idx].name">
              <router-link :to="{ name: 'plano-detalhes', params: { id: data[idx].id } }">{{ data[idx].name }}</router-link>
              <div>
                ID: {{ data[idx].id }}
              </div>
              <div class="my-2">
                <a :href="appPanelUrl + '/checkout/payment?planId=' + data[idx].id" target="_blank">Abrir Checkout com esse Plano</a>
              </div>

              <div v-show="data[idx].recurring === 'Sim'">
                <div class="mt-2" v-show="data[idx].paypal_plan_id"><strong>PayPal</strong><br>Plan ID: {{ data[idx].paypal_plan_id }} - Product ID: {{ data[idx].paypal_product_id }}</div>
                <div class="mt-2" v-show="data[idx].iugu_plan_id"><strong>Iugu</strong><br>Plan ID: {{ data[idx].iugu_plan_id }}</div>
                <div class="mt-2" v-show="data[idx].galaxpay_plan_id"><strong>GalaxPay</strong><br>Plan ID: {{ data[idx].galaxpay_plan_id }}</div>
              </div>
            </vs-td>
            <vs-td valign="top" :data="data[idx].setup_fee">{{ data[idx].setup_fee | money(data[idx].currency_code) }}</vs-td>
            <vs-td valign="top" :data="data[idx].fixed_price">{{ data[idx].fixed_price | money(data[idx].currency_code)}}</vs-td>
            <vs-td valign="top" :data="data[idx].interval_count">{{ data[idx].interval_count }} {{ data[idx].interval_unit | intervalUnit }}</vs-td>
            <vs-td valign="top" :data="data[idx].recurring" :class="{'text-success': data[idx].recurring === 'Sim', 'text-danger': data[idx].recurring === 'Não'}">{{ data[idx].recurring }}</vs-td>
            <vs-td valign="top" :data="data[idx].status" :class="{'text-success': data[idx].status === 'ACTIVE', 'text-danger': data[idx].status === 'INACTIVE', 'text-warning': data[idx].status === 'HIDDEN'}">{{ data[idx].status | statusPlans }}</vs-td>
            <vs-td valign="top" :data="data[idx].sort">{{ data[idx].sort }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div class="data-list-container mt-5 p-4" style="border: 1px dashed #ccc; border-radius: 4px;">
      <h4 class="mb-2 ml-1">Planos Ocultos</h4>
      <div>
        Esses planos podem ser comprados passando a ID do plano na URL, ex. /checkout/payment?planId=12
      </div>
      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado"
        :data="hiddenPlans"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>NOME</vs-th>
          <vs-th>ADESÃO</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>VALIDADE</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>NOVO CHECKOUT</vs-th>
          <vs-th>ORDEM</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td valign="top" :data="data[idx].name">
              <router-link :to="{ name: 'plano-detalhes', params: { id: data[idx].id } }">{{ data[idx].name }}</router-link>
              <div>
                ID: {{ data[idx].id }}
              </div>
              <div class="my-2">
                <a :href="appPanelUrl + '/checkout/payment?planId=' + data[idx].id" target="_blank">Abrir Checkout com esse Plano</a>
              </div>

              <div v-show="data[idx].recurring === 'Sim'">
                <div class="mt-2" v-show="data[idx].paypal_plan_id"><strong>PayPal</strong><br>Plan ID: {{ data[idx].paypal_plan_id }} - Product ID: {{ data[idx].paypal_product_id }}</div>
                <div class="mt-2" v-show="data[idx].iugu_plan_id"><strong>Iugu</strong><br>Plan ID: {{ data[idx].iugu_plan_id }}</div>
                <div class="mt-2" v-show="data[idx].galaxpay_plan_id"><strong>GalaxPay</strong><br>Plan ID: {{ data[idx].galaxpay_plan_id }}</div>
              </div>
            </vs-td>
            <vs-td valign="top" :data="data[idx].setup_fee">{{ data[idx].setup_fee | money(data[idx].currency_code) }}</vs-td>
            <vs-td valign="top" :data="data[idx].fixed_price">{{ data[idx].fixed_price | money(data[idx].currency_code)}}</vs-td>
            <vs-td valign="top" :data="data[idx].interval_count">{{ data[idx].interval_count }} {{ data[idx].interval_unit | intervalUnit }}</vs-td>
            <vs-td valign="top" :data="data[idx].recurring" :class="{'text-success': data[idx].recurring === 'Sim', 'text-danger': data[idx].recurring === 'Não'}">{{ data[idx].recurring }}</vs-td>
            <vs-td valign="top" :data="data[idx].status" :class="{'text-success': data[idx].status === 'ACTIVE', 'text-danger': data[idx].status === 'INACTIVE', 'text-warning': data[idx].status === 'HIDDEN'}">{{ data[idx].status | statusPlans }}</vs-td>
            <vs-td valign="top" :data="data[idx].status_new_checkout" :class="{'text-success': data[idx].status_new_checkout === 'ACTIVE', 'text-danger': data[idx].status_new_checkout === 'INACTIVE', 'text-warning': data[idx].status_new_checkout === 'HIDDEN'}">{{ data[idx].status_new_checkout | statusPlans }}</vs-td>
            <vs-td valign="top" :data="data[idx].sort">{{ data[idx].sort }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div class="data-list-container mt-5 p-4" style="border: 1px dashed #ccc; border-radius: 4px;">
      <h4 class="mb-2 ml-1">Planos Inativos</h4>
      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado"
        :data="inactivePlans"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>NOME</vs-th>
          <vs-th>ADESÃO</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>VALIDADE</vs-th>
          <vs-th>RECORRENTE</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>NOVO CHECKOUT</vs-th>
          <vs-th>ORDEM</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td valign="top" :data="data[idx].name">
              <router-link :to="{ name: 'plano-detalhes', params: { id: data[idx].id } }">{{ data[idx].name }}</router-link>
              <div>
                ID: {{ data[idx].id }}
              </div>
              <div v-show="data[idx].recurring === 'Sim'">
                <div class="mt-2" v-show="data[idx].paypal_plan_id"><strong>PayPal</strong><br>Plan ID: {{ data[idx].paypal_plan_id }} - Product ID: {{ data[idx].paypal_product_id }}</div>
                <div class="mt-2" v-show="data[idx].iugu_plan_id"><strong>Iugu</strong><br>Plan ID: {{ data[idx].iugu_plan_id }}</div>
                <div class="mt-2" v-show="data[idx].galaxpay_plan_id"><strong>GalaxPay</strong><br>Plan ID: {{ data[idx].galaxpay_plan_id }}</div>
              </div>
            </vs-td>
            <vs-td valign="top" :data="data[idx].setup_fee">{{ data[idx].setup_fee | money(data[idx].currency_code) }}</vs-td>
            <vs-td valign="top" :data="data[idx].fixed_price">{{ data[idx].fixed_price | money(data[idx].currency_code)}}</vs-td>
            <vs-td valign="top" :data="data[idx].interval_count">{{ data[idx].interval_count }} {{ data[idx].interval_unit | intervalUnit }}</vs-td>
            <vs-td valign="top" :data="data[idx].recurring" :class="{'text-success': data[idx].recurring === 'Sim', 'text-danger': data[idx].recurring === 'Não'}">{{ data[idx].recurring }}</vs-td>
            <vs-td valign="top" :data="data[idx].status" :class="{'text-success': data[idx].status === 'ACTIVE', 'text-danger': data[idx].status === 'INACTIVE', 'text-warning': data[idx].status === 'HIDDEN'}">{{ data[idx].status | statusPlans }}</vs-td>
            <vs-td valign="top" :data="data[idx].status_new_checkout" :class="{'text-success': data[idx].status_new_checkout === 'ACTIVE', 'text-danger': data[idx].status_new_checkout === 'INACTIVE', 'text-warning': data[idx].status_new_checkout === 'HIDDEN'}">{{ data[idx].status_new_checkout | statusPlans }}</vs-td>
            <vs-td valign="top" :data="data[idx].sort">{{ data[idx].sort }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appPanelUrl: process.env.VUE_APP_PANEL_URL,
      activePlans: [],
      inactivePlans: [],
      hiddenPlans: [],
      newCheckoutPlans: [],
      timeout: null
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.$vs.loading()

      this.$api
      .get('/api/v1/backend/planos')
      .then(response => {
        this.$vs.loading.close()
        this.newCheckoutPlans = response.data.filter(i => i.status_new_checkout === 'ACTIVE')
        this.activePlans = response.data.filter(i => i.status === 'ACTIVE' &&  i.status_new_checkout === 'INACTIVE')
        this.hiddenPlans = response.data.filter(i => i.status === 'HIDDEN')
        this.inactivePlans = response.data.filter(i => i.status === 'INACTIVE')
      })
    },
    add() {
      this.$router.push({name: 'plano-detalhes'})
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
